//import { PnkAjax } from '../api/pnk-ajax';
import { PnkAjax } from '../pnk-react/ajax/pnk-ajax';

export function CreateNewChatSession(store, data, successFunc) {
  let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
  console.log(data);
  return PnkAjax(store).Post('gpt/new-chat-session/json').ExtraData(data).AttachLoader(loader).OnSuccess(successFunc).Do();
}
export function GetChatSessionListByUser(store, data, successFunc) {
  let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
  return PnkAjax(store).Post('gpt/chat-session-list/json').ExtraData(data).AttachLoader(loader).OnSuccess(successFunc).Do();
}
export function SendMessage(store, data, successFunc) {
  let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
  return PnkAjax(store).Post('gpt/message/json').ExtraData(data).AttachLoader(loader).OnSuccess(successFunc).Do();
}
export function GetChatSessionDetails(store, data, successFunc) {
  let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
  return PnkAjax(store).Get('gpt/history/'+ data.txtUserName + '/' + data.sessionId).AttachLoader(loader).OnSuccess(successFunc).Do();
}